import React from "react";
import classNames from 'classnames';
import Svg from 'react-inlinesvg';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import bullsEyeArrow from '../../assets/svg/icons/bullseye-arrow.svg';
import handRock from '../../assets/svg/icons/hand-rock.svg';
import running from '../../assets/svg/icons/running.svg';
import bolt from '../../assets/svg/icons/bolt.svg';
import brain from '../../assets/svg/icons/brain.svg';
import shield from '../../assets/svg/icons/shield.svg';
import star from '../../assets/svg/icons/star.svg';
import icnDownloadReport from '../../assets/svg/icons/icn-download-report.svg';
import ilsFilePDF from '../../assets/svg/icons/ils-file-pdf.svg';
import ilsFileJPG from '../../assets/svg/icons/ils-file-jpg.svg';
import icnWatchlistDefault from '../../assets/svg/icons/icn-watchlist-default.svg';
import icnDownload from '../../assets/svg/icons/icn-download.svg';
import share from '../../assets/svg/icons/share-alt.svg';
import arrowToButton from '../../assets/svg/icons/arrow-to-bottom.svg';
import ilsGenerateSuccess from '../../assets/svg/ils/ils-report-Generated.svg';
import ilsNoSearch from '../../assets/svg/ils/ils-no-search.svg';
import ilsLoading from '../../assets/svg/ils/ils-loading.svg';
import ilsNoError from '../../assets/svg/ils/ils-no-error.svg';
import ilsCheck from '../../assets/svg/ils/ils-check.svg';
import ilsDelete from '../../assets/svg/ils/ils-delete.svg';
import ilsQuestion from '../../assets/svg/ils/ils-question.svg';
import ilsGoalWelcome from '../../assets/svg/ils/ils_goal.svg';
import ilsUserCheck from '../../assets/svg/ils/ils-user-check.svg';
import ilsMoon from '../../assets/svg/actions/icn-moon.svg';
import ilsSun from '../../assets/svg/actions/icn-sun.svg';
import arrowDown from '../../assets/svg/actions/icn-arrow-down.svg';
import arrowUp from '../../assets/svg/actions/icn-arrow-up.svg';
import chevronDown from '../../assets/svg/actions/icn-chevron-down.svg';
import chevronLeft from '../../assets/svg/actions/icn-chevron-left.svg';


import {Image} from "react-bootstrap";

export {bullsEyeArrow, handRock, running, bolt, brain, shield, star, arrowDown, arrowUp, chevronDown, chevronLeft, icnDownloadReport, ilsFilePDF, ilsFileJPG, icnWatchlistDefault, ilsGenerateSuccess, icnDownload, share, arrowToButton};
export {ilsNoSearch, ilsLoading, ilsNoError, ilsCheck, ilsDelete, ilsQuestion, ilsGoalWelcome, ilsUserCheck, ilsMoon, ilsSun};

/**
 * Renders FontAwesome or Svg icon
 */

const Icon = props => {
    const {icon, svg, className, ...others} = props;
    if (icon) return <FontAwesomeIcon className={classNames("icon", props.className)} icon={icon} {...others}/>;
    else if (svg) return <Image className={classNames("icon img-svg-icon", props.className)} src={svg} {...others}/>;
    else return 'ERROR LOADING ICON';
};

export default Icon;


